import type { User } from './user.types'

export enum CommentStatus {
  Comment = 0,
  OpenIssue = 1,
  ClosedIssue = 2,
}

export type Comment = {
  id: number
  authorId: number
  docId?: number
  controlId?: number
  replyCommentId?: number
  text: string
  status: CommentStatus
  createTs: string | Date
  updateTs: string | Date
  author?: Pick<User, 'id' | 'name' | 'email' | 'role'>
  replies?: Comment[]
}

export enum SubscriptionStatus {
  Subscribed = 0,
  MentionOnly = 1,
  Muted = 2,
}

export enum ActivityType {
  // Comments & Issues (10s)
  CommentCreated = 10,
  CommentReplied = 11,
  Mention = 12,
  IssueOpened = 13,
  IssueClosed = 14,

  // Document Lifecycle (20s)
  DocStagingStatusChanged = 20,
  DocLiveStatusChanged = 21,
  DocPicAssigned = 22,
  DocFileUploaded = 23,
  DocOfficiated = 24,
  DocArchived = 25,

  // Control Item Changes (30s)
  ControlStatusChanged = 30,
  ControlJustificationChanged = 31,

  // Control-Document Mapping (40s)
  ControlDocMapped = 40,
  ControlDocUnmapped = 41,
}

export type NotificationSubscription = {
  id: number
  userId: number
  docId?: number
  controlId?: number
  subscriptionStatus: SubscriptionStatus
  createTs: string | Date
  updateTs: string | Date
}

export type Notification = {
  id: number
  userId: number
  actorId?: number
  activityType: ActivityType
  commentId?: number
  docId?: number
  controlId?: number
  message?: string
  meta?: Record<string, unknown>

  /** Manual acknowledgment */
  readTs?: string | Date
  /** Hide until this time */
  snoozeUntilTs?: string | Date

  createTs: string | Date

  actor?: Pick<User, 'id' | 'name' | 'email' | 'role'>
  comment?: Comment
}
